<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="900px" :before-close="handleClose" @close="handleClose"
             v-if="dialogVisible">
<!--    <div class="ta-c pl30 pr30">-->
<!--      <img class="seal-img" :src="detailObj.sealImage" alt="">-->
<!--      <div class="mt15 fz24 fc3">{{ detailObj.sealName }}</div>-->
<!--    </div>-->
    <div class=" pl30 pr30">
      <div class="top-title flex-center">
        <img class="img-block" src="@/assets/user/icon-block.png" alt="">
        <span class="fc3 fz20">RSA认证信息</span>
      </div>
      <div class="info-area mt20">
        <el-descriptions title="" :column="1" v-loading="loading" border>
          <el-descriptions-item label="主题">{{ detailObj.subject }}</el-descriptions-item>
          <el-descriptions-item label="颁发人">{{ detailObj.issuer }}</el-descriptions-item>
          <el-descriptions-item label="认证序列号">{{ detailObj.serialNumber }}</el-descriptions-item>
          <el-descriptions-item label="认证名称">{{ detailObj.sigAlgName }}</el-descriptions-item>
          <el-descriptions-item label="有效期">{{ $moment(detailObj.notBefore).format('YYYY-MM-DD') }} 至 {{ $moment(detailObj.notAfter).format('YYYY-MM-DD') }}</el-descriptions-item>
          <el-descriptions-item label="认证版本">{{ detailObj.version }}</el-descriptions-item>
        </el-descriptions>
<!--        <div class="info-item">主题：{{ detailObj.subject }}</div>-->
<!--        <div class="info-item">颁发人：{{ detailObj.issuer }}</div>-->
<!--        <div class="info-item">认证序列号：{{ detailObj.serialNumber }}</div>-->
<!--        <div class="info-item">认证名称：{{ detailObj.sigAlgName }}</div>-->
<!--        <div class="info-item">有效期：{{ $moment(detailObj.notBefore).format('YYYY-MM-DD') }} 至 {{ $moment(detailObj.notAfter).format('YYYY-MM-DD') }}</div>-->
<!--        <div class="info-item">认证版本：{{ detailObj.version }}</div>-->
      </div>


    </div>

  </el-dialog>
</template>

<script>
export default {
  name: "defaultDetails",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      detailObj: {},
      title: '认证详情',
    };
  },
  methods:{
    show(e){
      this.detailObj = e
      this.dialogVisible = true
    },
    handleClose() {
      this.loading = false;
      this.dialogVisible = false;
    }
  }
}
</script>

<style lang="less" scoped>
.seal-img {
  width: 136px;
}

.top-title {
  .img-block {
    width: 12px;
    height: 12px;
    margin-right: 8px;
  }
}

.info-area {
  border-top: 1px solid rgb(238, 238, 238);
  border-right: 1px solid rgb(238, 238, 238);
  border-bottom: none;
  border-left: 1px solid rgb(238, 238, 238);

  .info-item {
    display: flex;
    padding: 15px 20px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
  }
}

::v-deep .el-dialog__body {
  padding: 30px 20px 50px !important;
}
</style>
